import SkyeBasicThemes from "../Themes/SkyeBasicThemes.js";
import ImageRollovers from "../ImageRolloverClass.js";
import BannerImagePreloader from "../BannerImagePreloader/BannerImagePreloader.js";
import A11yHelpers from "../A11yHelpers.js";

/**
 * Image Preloader Implementation
 * 
 */
var DataForPreloadingWithThemes = {
  pages: {
    about: [
      'about-us-page-header-bg-mobile.jpg',
      'about-us-page-header-bg-mobile.jpg',
      'about-us-page-header-bg-tablet-sm.jpg',
      'about-us-page-header-bg-tablet.jpg',
      'about-pmi.png',
      'about-shrm.png',
      'about-hrci.png',
      'about-cpe.png',
      'about-cfre.png',
      'about-authorized-provider.png'
    ],
    business: [
      'business-page-header-bg-mobile.jpg',
      'business-page-header-bg-tablet-sm.jpg',
      'business-page-header-bg-tablet.jpg',
      'business-panel-bg-desktop.jpg'
    ],
    certsearch: [
      'certsearch-page-header-bg-desktop.jpg',
      'certsearch-page-header-bg-tablet.jpg',
      'certsearch-page-header-bg-tablet-sm.jpg',
      'certsearch-page-header-bg-mobile.jpg'
    ],
    home: {
      standard: [
        // 'home-page-header-bg-desktop.jpg',
        // 'home-page-header-bg-mobile.jpg',
        // 'home-page-header-bg-tablet.jpg',
        // 'home-page-header-bg-tablet-sm.jpg'
      ],
      snowmountain: [
        // 'home-page-header-bg-desktop-snow-mountain.jpg',
        // 'home-page-header-bg-mobile-snow-mountain.jpg',
        // 'home-page-header-bg-tablet-snow-mountain.jpg',
        // 'home-page-header-bg-tablet-sm-snow-mountain.jpg'
      ]
    },
    newsroom: [],
    sixsigma: [
      'six-sigma-banner-image.png',
      'six-sigma-pyramid.png',
      'six-sigma-solo.png'
    ],
    category: [],
    product: [],
    cart: [],
    privacy: [],
    csurvey: [],
    support: [],
  },
  theme: {
    data: [
      {
        class: "theme--skye-standard",
        imgPrefix: "https://cdn.skyelearning.com/static/",
      },
      {
        class: "theme--skye-snow-mountain",
        imgPrefix:
          "https://cdn.skyelearning.com/static/themes/skye-snow-mountain/",
      }
    ],
    imgNames: {
      tablet: "skye-tab-logo.svg",
      desktop: "skye-desk-logo.svg"
    },
    imgTargets: {
      desktopLogo: ".auxiliary-navbar__desktop__logo",
      tabletLogo: ".auxiliary-navbar__tablet__logo"
    }
  }

};

let pageContent = document.querySelector('#pageContent'); // get the content area for current page.
let preloadImages = new BannerImagePreloader(pageContent);

preloadImages.setImageArray(DataForPreloadingWithThemes);
preloadImages.selectKey();
preloadImages.runPreloadingLoop();
/**
 * SkyeThemesClass Implementation
 */
let themeBodyElement = document.querySelector("body");
let __skyeBasicThemes = new SkyeBasicThemes(
  themeBodyElement,
  DataForPreloadingWithThemes
);
__skyeBasicThemes.activateTheme();


/**
 * Image Rollovers Implementation
 */
var ImageClassObjectArray = {
  RolloverTargets: [
    ".side-menu__corp__logo",
    ".bucket-test-img",
    ".flow-chart-img",
    ".navigation-logo__tablet",
    ".navigation-logo__mobile",
    ".navigation-logo__desktop"
  ],
  // Elements to be processed through theme data for rollovers.
  ThemeTargets: [
    "auxiliary-navbar__desktop__logo",
    "auxiliary-navbar__tablet__logo"
  ]
};

var imageSourcePrefix = "https://cdn.skyelearning.com/static/skye-logos/";
var themeDetection = __skyeBasicThemes.detectTheme();

let AddRolloverImages = new ImageRollovers(
  ImageClassObjectArray,
  imageSourcePrefix,
  themeDetection
);
AddRolloverImages.ProcessRollovers();

/* Instantiate and execute the offscreen content generator for screenreading assistance. */
const a11y = new A11yHelpers();
a11y.createOffScreenContent();